import React, { useEffect } from 'react'
import { Card } from 'react-bootstrap'
import { Outlet, useOutletContext, useParams } from 'react-router-dom'
import NavbarEmpInfo from '../navbar-emp-info'
import { use } from 'react'
import { getEmpsDetailsByUUIDAPI } from '../../../../services/employee'
import { useDispatch } from 'react-redux'
import { updateProfileID } from '../../../../actions/profile.action'

function EmployeeInfo() {
  const { dataUser } = useOutletContext()
  return (
    <>
      <NavbarEmpInfo />
      <Card.Body className="overflow-auto">
        <Outlet context={{ dataUser }} />
      </Card.Body>
    </>
  )
}

export default EmployeeInfo
